import { render } from "./ToolbarContainer.vue?vue&type=template&id=1c5384c4"
import script from "./ToolbarContainer.vue?vue&type=script&lang=js"
export * from "./ToolbarContainer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__